import { useQuery } from "@tanstack/react-query";
import { getEntitiesByIdUsuario, getInfoEntidad } from "../services/User.service"
import type { Entidad } from "../types/interfaces/user.interface"
import type { SelectGeneric } from "../../modules/casos/types/interfaces/ApiConsultaGestionCasos/Generic";

/**
 * Hook personalizado que utiliza useQuery para obtener información de una entidad de usuario.
 *
 * @param idUsuario - Identificador del usuario
 * @param idEntidad - Identificador de la entidad
 * @returns Objeto de consulta que contiene datos, estado de carga y posibles errores
 * Características:
 * - Almacena en caché los resultados
 * - Revalida automáticamente los datos cuando es necesario
 * - Proporciona funciones para refrescar manualmente los datos
 */
const useGetInfoEntidadUsuario = (idUsuario: number, idEntidad: number) => {
    return useQuery<Entidad>({
        queryKey: ['infoEntidadUsuario', idUsuario, idEntidad],
        queryFn: async () => await getInfoEntidad(idUsuario, idEntidad),
        enabled: !!idUsuario && !!idEntidad,
        refetchOnWindowFocus: false
    });
}

/**
 * Hook personalizado que utiliza useQuery para obtener entidades de un usuario.
 *
 * @param idUsuario - Identificador del usuario
 * @returns 
 */
const useGetEntitiesByIdUsuario = (idUsuario: number) => {
    return useQuery<SelectGeneric[]>({
        queryKey: ['entitiesByUserId', idUsuario], //FIXME: <-- agregar una key reutilizable
        queryFn: async () => await getEntitiesByIdUsuario(idUsuario),
        refetchOnWindowFocus: false
    });
}
export {
    useGetInfoEntidadUsuario,
    useGetEntitiesByIdUsuario
}